import React, { useEffect } from "react";
import * as THREE from "three";
import { useGLTF, useAnimations } from "@react-three/drei";

export default function Model({ url, scale, position, rotation }) {
  const gltf = useGLTF(url);
  const { scene, animations } = gltf;

  const { actions } = useAnimations(animations, scene);

  useEffect(() => {
    if (actions) {
      Object.values(actions).forEach((a) => a.play());
    }

    scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;

        if (child.material?.map) {
          child.material.map.colorSpace = THREE.SRGBColorSpace;
        }

        if (child.material?.emissiveMap) {
          child.material.emissiveMap.colorSpace = THREE.SRGBColorSpace;
        }

        child.material.envMapIntensity = 1;
      }
    });
  }, [actions, scene]);

  return (
    <primitive
      object={scene}
      scale={scale}
      position={position}
      rotation={rotation}
    />
  );
}

useGLTF.preload("/3dtshirt.glb");